import React from "react";
import LegalPage, { DocSections } from "@/pages/legal/LegalPage";
import { CARRIER } from "@/pages/legal/_content";

const CarrierAgreement = () => <LegalPage doc={CARRIER}><DocSections sections={CARRIER.sections}/></LegalPage>;
export default CarrierAgreement;
